export enum TransactionReceiptStatus {
  Fail,
  Success,
}
